import script from "./ds-modal-video.vue?vue&type=script&setup=true&lang=ts"
export * from "./ds-modal-video.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__